import { render, staticRenderFns } from "./taxManagement.vue?vue&type=template&id=064d28cf&scoped=true"
import script from "./taxManagement.vue?vue&type=script&lang=js"
export * from "./taxManagement.vue?vue&type=script&lang=js"
import style0 from "./taxManagement.vue?vue&type=style&index=0&id=064d28cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064d28cf",
  null
  
)

export default component.exports